import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

export default register('featured-articles', {
  onLoad() {
    this.sliderId = '#articles__slider--' + this.id;
    const thisSlider = document.querySelector('#articles__slider--' + this.id);

    var slider = new Flickity(thisSlider, {
      // options
      freeScroll: false,
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      imagesLoaded: true,
      setGallerySize: true,
      cellAlign: 'left',
      watchCSS: true,
      wrapAround: false,
    });
  },
});
